module.exports = __webpack_public_path__ + "img/hire3xai.2c38bc4f.svg";